module.exports = __webpack_public_path__ + "img/hbpn.b232bfc5.png";